import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

import CardModelMasonry from '@/components/card/CardModelMasonry';
import ClientOnly from '@/components/client-only';
import NoData from '@/components/NoData';
import RenderWhen from '@/components/RenderWhen';
import useWindowSize from '@/hooks/useWindowSize';

import ModelSkeleton from './Skeletion';
import useFetchList from './useFetchList';

const ListAiModel: React.FC = () => {
  const { isMobileView } = useWindowSize();
  const { list, currentPage, loadMore, loading } = useFetchList();

  return (
    <ClientOnly skeleton={<ModelSkeleton />}>
      <section>
        <RenderWhen>
          <RenderWhen.If isTrue={list.length === 0 && !loading}>
            <NoData />
          </RenderWhen.If>
          <RenderWhen.If isTrue={list.length > 0}>
            <InfiniteScroll
              style={{ overflow: 'hidden' }}
              dataLength={list.length}
              next={() => {
                loadMore(currentPage + 1);
              }}
              hasMore
              loader=""
            >
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 4, 1800: 5 }}
              >
                <Masonry gutter={isMobileView ? '8px' : '12px'}>
                  {list.map((model) => (
                    <CardModelMasonry key={model.id} model={model} />
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            </InfiniteScroll>
          </RenderWhen.If>
        </RenderWhen>
      </section>
    </ClientOnly>
  );
};

export default ListAiModel;
